import { observer } from 'mobx-react-lite';
import LayerLabelItem from './LayerLabelItem';
import type { LayerLabelItemProps, LayerLabelItemValueProps } from './types';

export type { LayerLabelItemProps, LayerLabelItemValueProps };
export default observer(LayerLabelItem); // MANUAL OVERRIDE
